var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{key:_vm.key,staticClass:"coin",class:{ large: _vm.large, big: _vm.big, medium: _vm.medium },attrs:{"onerror":_vm.onError,"width":"20px","height":"20px","src":_vm.coinUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }